export default __webpack_public_path__ + "static/medtner-op-38-f4889edfe271a3731f242a1b829a9f5b.mp3";